import React from "react";

export const PopupEvent = ({ event, removeItem, canCreateItems, editItem }) => {
  let classes = [];

  const event_title = event.title.split(' ');
  if (event_title.length > 1 && event.title.indexOf('vakantie') >= 0) {
    event.slug = event_title[0].concat(" ", event_title[1]);
  }

  if (event.created_by != null) classes.push("isUserEvent");

  const notesRef = React.useRef(null);

  const editMe = () => {
    editItem(event);
  }

  return (
    <li>
      {event.created_by != null ? (
        <>

          {canCreateItems ? (
              <>
                  <span onClick={editMe} style={{"cursor":"pointer"}} className={Array.from(new Set(classes)).join(" ")}>
            {event.title}&nbsp;{event.notes != '' && (<div style={{float:"right",cursor:"pointer"}} onClick={event1 => (notesRef.current.classList.toggle('active'))}><svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                    <path id="note-sticky-regular" d="M11.143,32H1.857A1.857,1.857,0,0,0,0,33.857v9.26A1.864,1.864,0,0,0,1.857,45H8.592a2.787,2.787,0,0,0,1.97-.816l1.622-1.622A2.827,2.827,0,0,0,13,40.592V33.857A1.863,1.863,0,0,0,11.143,32ZM1.529,43.471a.456.456,0,0,1-.136-.328v-9.26a.471.471,0,0,1,.464-.49h9.285a.471.471,0,0,1,.464.464v5.571H9.054a1.626,1.626,0,0,0-1.625,1.625v2.554H1.857A.456.456,0,0,1,1.529,43.471Zm8.05-.273a1.379,1.379,0,0,1-.757.386v-2.53a.233.233,0,0,1,.232-.232h2.531a1.378,1.378,0,0,1-.386.756Z" transform="translate(0 -32)" fill="#0E6C53"/>
                  </svg></div>)}<br/>
                    {event.start_time != '00:00' || event.end_time != '23:59' ? (<small className={'hours'}>{event.start_time} - {event.end_time} uur</small>):(<></>)}
                    <div className={'notes'} ref={notesRef}>{event.notes}</div>
          </span>
          <button
            className="calendar__popupRemoveEventBtn"
            onClick={e =>
              removeItem(e, event, (res, err) => {
                // Do some stuff here
              })
            }
          /></>):(<span className={Array.from(new Set(classes)).join(" ")}>
            {event.title}&nbsp;{event.notes != '' && (<div style={{float:"right",cursor:"pointer"}} onClick={event1 => (notesRef.current.classList.toggle('active'))}><svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
            <path id="note-sticky-regular" d="M11.143,32H1.857A1.857,1.857,0,0,0,0,33.857v9.26A1.864,1.864,0,0,0,1.857,45H8.592a2.787,2.787,0,0,0,1.97-.816l1.622-1.622A2.827,2.827,0,0,0,13,40.592V33.857A1.863,1.863,0,0,0,11.143,32ZM1.529,43.471a.456.456,0,0,1-.136-.328v-9.26a.471.471,0,0,1,.464-.49h9.285a.471.471,0,0,1,.464.464v5.571H9.054a1.626,1.626,0,0,0-1.625,1.625v2.554H1.857A.456.456,0,0,1,1.529,43.471Zm8.05-.273a1.379,1.379,0,0,1-.757.386v-2.53a.233.233,0,0,1,.232-.232h2.531a1.378,1.378,0,0,1-.386.756Z" transform="translate(0 -32)" fill="#0E6C53"/>
          </svg></div>)}<br/>
            {event.start_time != '00:00' || event.end_time != '23:59' ? (<small className={'hours'}>{event.start_time} - {event.end_time} uur</small>):(<></>)}
            <div className={'notes'} ref={notesRef}>{event.notes}</div>
          </span>)}
        </>
      ) : (
        <a className={Array.from(new Set(classes)).join(" ")} href={event.url}>
          {event.title}
          {event.start_time != '00:00' || event.end_time != '23:59' ? (<small className={'hours'}>{event.start_time} - {event.end_time} uur</small>):(<></>)}
        </a>
      )}
    </li>
  );
};
